import { programConfig } from "./program-config";
import type { LoanInput } from "./types";

export const calculateUnderwritingFeePercentage = (
  loanInput: Partial<LoanInput>,
  loanAmount: number
): number | null => {
  console.log("calculateUnderwritingFeePercentage", "Starting calculation", {
    loanInput,
    loanAmount,
  });

  if (!loanInput.lenderFeeBuyOut) {
    console.log(
      "calculateUnderwritingFeePercentage",
      "Lender fee buyout not enabled"
    );
    return null;
  }

  // Extract just the program part if program is in 'program:mortgageType' format
  const programParts = loanInput.program?.split(":") || [];
  const program = programParts[0];
  if (!program) {
    console.log("calculateUnderwritingFeePercentage", "No program specified");
    return null;
  }

  const programConfigData = programConfig.programConfigs[program];
  if (!programConfigData || !programConfigData.fees) {
    console.log(
      "calculateUnderwritingFeePercentage",
      "No program config or fees found",
      { program }
    );
    return null;
  }

  const underwritingFee = programConfigData.fees.underwritingFee;
  console.log("calculateUnderwritingFeePercentage", "Found underwriting fee", {
    underwritingFee,
  });

  // Calculate the percentage
  const percentage = (underwritingFee / loanAmount) * 100;
  console.log("calculateUnderwritingFeePercentage", "Calculation complete", {
    underwritingFee,
    loanAmount,
    percentage,
  });

  return percentage;
};
